/**
 * TermsOfService — the portal's Terms and Conditions page (14 Oct 2026, v2.0).
 * The legal text lives in ONE place: https://cetalingua.com/terms-and-conditions/ (covers the website, this portal, FM and Trips).
 * This page links there, so the portal can never show an outdated copy. Props: onBack (unchanged).
 */
import React from 'react';

const URL = 'https://cetalingua.com/terms-and-conditions/';

export default function TermsOfService({ onBack }) {
  return (
    <div style={{ minHeight: '100vh', background: '#0A1929', color: '#e8f1f8', padding: '48px 16px', boxSizing: 'border-box' }}>
      <div style={{ maxWidth: 680, margin: '0 auto', background: '#0f2537', border: '1px solid #23405a', borderRadius: 14, padding: '28px 24px' }}>
        <h1 style={{ marginTop: 0, fontSize: 28 }}>Terms and Conditions</h1>
        <p style={{ lineHeight: 1.6, color: '#b8c9d9' }}>The Terms and Conditions for the Cetalingua portal, Cetalingua FM, Cetalingua Trips and cetalingua.com are published in one place, on our website.</p>
        <p style={{ margin: '24px 0' }}>
          <a href={URL} target="_blank" rel="noopener noreferrer"
            style={{ display: 'inline-block', padding: '12px 20px', borderRadius: 10, background: '#1e88e5', color: '#fff', textDecoration: 'none', fontWeight: 600 }}>
            Read the Terms and Conditions (version 2.0) ↗
          </a>
        </p>
        <p style={{ lineHeight: 1.6, color: '#b8c9d9', fontSize: 14 }}>
          Questions: <a href="mailto:research@cetalingua.com" style={{ color: '#4fc3f7' }}>research@cetalingua.com</a>
        </p>
        {onBack && (
          <button type="button" onClick={onBack}
            style={{ marginTop: 8, padding: '10px 18px', borderRadius: 10, border: '1px solid #23405a', background: 'transparent', color: '#e8f1f8', cursor: 'pointer', fontSize: 15 }}>
            ← Back
          </button>
        )}
      </div>
    </div>
  );
}
